// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background: #fff !important;
  padding: 3rem 2rem 1.5rem;
  border-top: 1px solid rgba(0, 163, 255, 0.2);
  border-radius: 5px;
}

.footer-content {
  max-width: 1400px;
  margin: 0 auto 2rem;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 3rem;
}

.footer-section h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, #ffffff 0%, #00a3ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.footer-section h4 {
  font-size: 1.1rem;
  margin-bottom: 1rem;
  color: #ffffff;
}

.footer-section p {
  color: #b0b0b0;
  line-height: 1.6;
}

.footer-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-section ul li {
  margin-bottom: 0.5rem;
}

.footer-section ul li a {
  color: #b0b0b0;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-section ul li a:hover {
  color: #00a3ff;
}
.quick-links-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  background: linear-gradient(185deg, #ffffff 0%, #00a3ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.footer-bottom {
  max-width: 1400px;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(0, 163, 255, 0.2);
  text-align: center;
  margin-bottom: 20px;
}

.footer-bottom p {
  color: #666;
  margin: 0;
}
.footer-text {
  color: #000000a2;
  text-align: start;
}
.footer-logo {
  text-align: center;
}

@media (max-width: 768px) {
  .footer {
    padding: 2rem 1.25rem 1rem;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 2rem;
    text-align: center;
  }

  .footer-text {
    text-align: center;
  }

  .footer-logo img {
    width: 70%;
    max-width: 220px;
    height: auto;
  }

  .footer-section ul {
    display: inline-block;
    text-align: left;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/footer/Fotter.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;AACF","sourcesContent":[".footer {\n  background: #fff !important;\n  padding: 3rem 2rem 1.5rem;\n  border-top: 1px solid rgba(0, 163, 255, 0.2);\n  border-radius: 5px;\n}\n\n.footer-content {\n  max-width: 1400px;\n  margin: 0 auto 2rem;\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 3rem;\n}\n\n.footer-section h3 {\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n  background: linear-gradient(135deg, #ffffff 0%, #00a3ff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.footer-section h4 {\n  font-size: 1.1rem;\n  margin-bottom: 1rem;\n  color: #ffffff;\n}\n\n.footer-section p {\n  color: #b0b0b0;\n  line-height: 1.6;\n}\n\n.footer-section ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.footer-section ul li {\n  margin-bottom: 0.5rem;\n}\n\n.footer-section ul li a {\n  color: #b0b0b0;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.footer-section ul li a:hover {\n  color: #00a3ff;\n}\n.quick-links-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n  background: linear-gradient(185deg, #ffffff 0%, #00a3ff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n.footer-bottom {\n  max-width: 1400px;\n  padding-top: 1.5rem;\n  border-top: 1px solid rgba(0, 163, 255, 0.2);\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.footer-bottom p {\n  color: #666;\n  margin: 0;\n}\n.footer-text {\n  color: #000000a2;\n  text-align: start;\n}\n.footer-logo {\n  text-align: center;\n}\n\n@media (max-width: 768px) {\n  .footer {\n    padding: 2rem 1.25rem 1rem;\n  }\n\n  .footer-content {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n    text-align: center;\n  }\n\n  .footer-text {\n    text-align: center;\n  }\n\n  .footer-logo img {\n    width: 70%;\n    max-width: 220px;\n    height: auto;\n  }\n\n  .footer-section ul {\n    display: inline-block;\n    text-align: left;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
